import React, { useState } from 'react';
import Form from './Form';

function not(value: boolean) {
  return !value;
}

const Subscribe = () => {
  const [showSuccessMessage, setSuccessMessage] = useState(false);

  const handleSubscribe = (success: boolean) => {
    if (!success) {
      return;
    }
    setSuccessMessage(true);
    setTimeout(hideSuccessMessage, 5000);
  };

  const hideSuccessMessage = () => setSuccessMessage(false);

  return (
    <section className="bg-green-200 py-20 px-5">
      {showSuccessMessage && (
        <div className="flex items-center flex-col max-w-7xl mx-auto">
          <h2 className="text-white text-4xl text-center md:text-left">
            ¡Gracias por suscribirte!
          </h2>
          <p className="text-white text-center md:text-left md:text-xl">
            Pronto estarás enteredado de las mejores oportunidades de inversión.
          </p>
        </div>
      )}
      {not(showSuccessMessage) && (
        <div className="flex flex-col max-w-7xl mx-auto md:flex-row xl:justify-between">
          <div className="mb-4 md:mb-0 max-w-lg w-5/12">
            <h2 className="text-white text-4xl text-center md:text-left">
              ¡Suscríbete!
            </h2>
            <p className="text-white text-center md:text-left md:text-xl">
              Recibe notificaciones sobre las mejores oportunidades de
              inversión.
            </p>
          </div>
          <div className="mt-4 w-full xl:w-1/2 subscribe">
            <Form onSubscribe={handleSubscribe} />
          </div>
        </div>
      )}
    </section>
  );
};

export default Subscribe;
